export default __webpack_public_path__ + "static/media/backmp4.1d6525b2.mp4";